import { useState, useEffect } from "react";

export type UserRole = "admin" | "operator" | "viewer" | null;

export interface AuthUser {
  username: string;
  role: UserRole;
  tenant: string;
  displayName: string;
}

const AUTH_KEY = "gas_auth_user";

export function useAuth() {
  const [user, setUser] = useState<AuthUser | null>(() => {
    try {
      const stored = sessionStorage.getItem(AUTH_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const login = (authUser: AuthUser) => {
    sessionStorage.setItem(AUTH_KEY, JSON.stringify(authUser));
    setUser(authUser);
  };

  const logout = () => {
    sessionStorage.removeItem(AUTH_KEY);
    setUser(null);
  };

  const isLoggedIn = user !== null;

  return { user, login, logout, isLoggedIn };
}

// Role-based menu permissions
export const ROLE_PERMISSIONS: Record<NonNullable<UserRole>, string[]> = {
  admin: [
    "dashboard", "customer", "meter", "sales", "fee", "bank",
    "safety", "install", "report", "query", "sms", "material",
    "online", "service", "saas", "settings",
  ],
  operator: [
    "dashboard", "customer", "meter", "sales", "fee", "bank",
    "safety", "install", "report", "query", "sms", "material",
    "online", "service",
  ],
  viewer: [
    "dashboard", "query", "report",
  ],
};
